import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext, useWatch } from "react-hook-form";
import { CustomDatePicker } from "shared/components/date/CustomDatePicker";
import CustomNumberInput from "shared/components/input/CustomNumberInput";
import TextInput from "shared/components/input/TextInput";
import CustomSwitch from "shared/components/Switch/CustomSwitch";
import { formatarValorMonetario } from "shared/util/functions/formatacoesDeValores/FormatarValores";

const SecaoBaixaContaPrincipal: React.FC = () => {
  const { control, register, setValue, watch } = useFormContext();
  const [incluirAcrescimosDescontos, setIncluirAcrescimosDescontos] = useState(false);
  const [showCampoCheque, setShowCampoCheque] = useState(false);

  const handleToggleAcrescimosDescontos = () => {
    const novoEstado = !incluirAcrescimosDescontos;
    setIncluirAcrescimosDescontos(novoEstado);
    if (!novoEstado) {
      setValue("juros", 0);
      setValue("multa", 0);
      setValue("desconto", 0);
    }
  };

  const style = { fontWeight: "bold", color: "#676A6C" };

  const formaPagamento = useWatch({ name: "tipoFormaPagamento" });
  const valorPago = useWatch({ name: "valorPago", defaultValue: 0 });

  useEffect(() => {
    if (formaPagamento?.value === "CHEQUE") {
      setShowCampoCheque(true);
    } else {
      setShowCampoCheque(false);
      setValue("numeroCheque", "");
    }
  }, [formaPagamento, setValue]);

  return (
    <div>
      <Row>
        <Col md={3}>
          <CustomDatePicker
            name="dataPagamento"
            label="Data de pagamento"
            control={control}
            register={register}
            setValue={setValue}
            usarValidacaoParaFormulario
            style={{ width: "100%" }}
          />
        </Col>
        <Col md={3}>
          <CustomDatePicker
            name="dataLiquidacao"
            label="Data de liquidação"
            control={control}
            register={register}
            setValue={setValue}
            usarValidacaoParaFormulario
            style={{ width: "100%" }}
          />
        </Col>
        {showCampoCheque && (
          <Col xs={3}>
            <TextInput
              usarValidacaoParaFormulario={true}
              id="numeroCheque"
              label="Número do cheque"
              name="numeroCheque"
              control={control}
              setValue={setValue}
              register={register}
            />
          </Col>
        )}
        <Col md={3}>
          <div className="form-group">
            <label className="form-label" style={style}>
              Origem da baixa
            </label>
            <p className="form-control-static">Group Pay</p>
          </div>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <CustomSwitch
            name={"incluirAcrescimosDescontos"}
            labelDireito="Incluir acréscimos/descontos"
            onChange={handleToggleAcrescimosDescontos}
            checked={incluirAcrescimosDescontos}
            control={control}
            register={register}
            setValue={setValue}
            usarValidacaoParaFormulario
          />
        </Col>
      </Row>

      {incluirAcrescimosDescontos && (
        <Row className="mt-3">
          <Col md={3}>
            <CustomNumberInput
              id="juros"
              name="juros"
              label="Juros (R$)"
              prefix="R$ "
              control={control}
              register={register}
              setValue={setValue}
              decimalScale={2}
              usarValidacaoParaFormulario
              fixedDecimalScale={true}
              allowLeadingZeros={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return void 0 === floatValue || (floatValue >= 0 && floatValue <= 999999999999.99);
              }}
            />
          </Col>
          <Col md={3}>
            <CustomNumberInput
              id="multa"
              name="multa"
              label="Multa (R$)"
              prefix="R$ "
              control={control}
              register={register}
              setValue={setValue}
              decimalScale={2}
              usarValidacaoParaFormulario
              fixedDecimalScale={true}
              allowLeadingZeros={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return void 0 === floatValue || (floatValue >= 0 && floatValue <= 999999999999.99);
              }}
            />
          </Col>
          <Col md={3}>
            <CustomNumberInput
              id="desconto"
              name="desconto"
              label="Desconto (R$)"
              prefix="R$ "
              control={control}
              register={register}
              setValue={setValue}
              decimalScale={2}
              usarValidacaoParaFormulario
              fixedDecimalScale={true}
              allowLeadingZeros={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return void 0 === floatValue || (floatValue >= 0 && floatValue <= 999999999999.99);
              }}
            />
          </Col>
        </Row>
      )}
      <Row className="mt-4">
        <Col md={3}>
          <div className="form-group">
            <label className="form-label" style={style}>
              Valor pago (R$)
            </label>
            <p className="form-control-static">{formatarValorMonetario(valorPago || 0)}</p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SecaoBaixaContaPrincipal;
